import React from 'react'

import './button.sass'

const Button = props => (
  <a
    className={props.cssClass}
    href={props.href}
    target={props.target}
    rel={props.rel}
  >
    {props.children}
  </a>
)

export default Button
